import "babel-polyfill";
import './app.sss';
import FilterDataEvents from './modules/FilterDataEvents';
import GoTo from './modules/GoTo';
import RemoveMessage from './modules/RemoveMessage';

class Index {
  constructor() {
    new FilterDataEvents();
    new GoTo();
    RemoveMessage();
  }
}


(jQuery|| $)(function () {
  new Index()
});



// WEBPACK FOOTER //
// ./app.js